



























import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FeatureModule } from "@/store/modules/feature.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component } from "vue-property-decorator";
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import { mixins } from "vue-class-component";
import CanMixin from "@/mixins/CanMixin.vue";

@Component
export default class TheThgPartnerList extends mixins(CanMixin) {
  loading = false;

  get partnerId() {
    return PartnerModule?.partner?._id;
  }

  get partnerItems() {
    const items: IMenuListItem[] = [
      {
        icon: "mdi-view-dashboard-outline",
        text: "navigation.TheThgAdminList.overview",
        link: `/partners/${this.partnerId}/home`,
        permission: {
          resource: ResourceEnum.THG,
          action: ActionEnum.MANAGE
        }
      },
      {
        icon: "mdi-car-outline",
        text: "navigation.TheThgAdminList.thg",
        link: `/partners/${this.partnerId}/thg`,
        permission: {
          resource: ResourceEnum.THG,
          action: ActionEnum.MANAGE
        }
      }
    ];

    if (FeatureModule.isTemplateEnabled) {
      items.push({
        icon: "mdi-book",
        text: "Templates",
        link: `/partner/${this.partnerId}/template`,
        permission: {
          resource: ResourceEnum.TEMPLATE,
          action: ActionEnum.READ
        }
      });
    }

    return items;
  }

  get affiliateItems() {
    return [
      {
        icon: "mdi-gift-outline",
        text: "navigation.TheThgAdminList.affiliates",
        link: `/partners/${this.partnerId}/affiliate`
      }
    ];
  }
}
